<template>
  <a
    @click.prevent="$emit('click', !active)"
    class="waves-effect waves-light btn btn-icon secondary-content--hidden"
    :class="{ active }"
  >
    <feather type="trash-2" size="24" />
  </a>
</template>

<script>
export default {
  name: "HiddenItemButton",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.waves-effect.waves-light.btn.btn-icon.secondary-content--hidden.active {
  padding: 0;
  background-color: #2fad34;
  &:hover {
    background-color: #3ec743 !important;
  }
}
.waves-effect.waves-light.btn.btn-icon.secondary-content--hidden {
  min-width: 36px;
  min-height: 36px;
  padding: 0;
  background-color: #e12929;
  &:hover {
    background-color: #ff7f7f !important;
  }
}
</style>
